<p-table #tabellaIndirizzi [value]="(indirizziProvv$ | async)??[]" [paginator]="true" [rows]="10"
  [alwaysShowPaginator]="false">
  <ng-template pTemplate="header">
    <tr>
      <th id="indirizzo">Indirizzo</th>
      <th id="comandi" class="w-6rem" rowspan="2"></th>
    </tr>
    <tr>
      <th id="filtro">
        <input pInputText type="text" placeholder="Filtra..."
          (input)="tabellaIndirizzi.filter($any($event.target).value, 'nomeIndirizzo', 'contains')">
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-indirizzo>
    <tr>
      <td>{{ indirizzo.nomeIndirizzo }}</td>
      <td class="flex align-content-end">
        <button pButton type="button" icon="fas fa-check" (click)="confirmIndirizzo(indirizzo)" class="p-button-primary mr-1"
          title="Conferma Indirizzo" ></button>
        <button pButton type="button" icon="fas fa-list" (click)="associaIndirizzo(indirizzo)" class="p-button-info  mr-1"
          title="Associa a indirizzo esistente"></button>
          <button pButton type="button" icon="fas fa-times" class="p-button-danger" title="Elimina"
          (click)="removeItem(indirizzo)"></button>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog [(visible)]="showConfermaDialog" [modal]="true" [closable]="false" [closeOnEscape]="false" [style]="{ width: '30%' }">
  <p-header>
    <span class="font-normal">Associa <b>{{selectedIndirizzo?.nomeIndirizzo}}</b> a Indirizzo esistente</span>
  </p-header>
  <p-table #tabellaConfermati [value]="indirizziConfermati" [paginator]="true" [rows]="10" [alwaysShowPaginator]="false">
    <ng-template pTemplate="header">
      <tr>
        <th id="indirizzo_conf">Indirizzo</th>
        <th id="comandi_conf"  class="w-6rem align-content-start" rowspan="2">Associa</th>
      </tr>
      <tr>
        <th id="filtro_conf">
          <input pInputText type="text" placeholder="Filtra..." class="w-full"
            (input)="tabellaConfermati.filter($any($event.target).value, 'nomeIndirizzo', 'contains')">
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-indirizzo>
      <tr>
        <td>{{indirizzo.nomeIndirizzo}}</td>
        <td class="text-center">
          <button pButton type="button" icon="fa fa-exchange"
            (click)="associaIndirizzoaEsistente(selectedIndirizzo, indirizzo)" class="p-button-primary" [disabled]="!selectedIndirizzo"
            title="Associa a questo indirizzo"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-footer>
    <button pButton type="button" label="Annulla" class="p-button-secondary" icon="pi pi-times" title="Annulla"
      (click)="closeDialog()"></button>
  </p-footer>
</p-dialog>

<p-dialog [(visible)]="showHideDialog" [modal]="true" [closable]="false" [closeOnEscape]="false" [style]="{ width: '30%' }">
  <p-header>
    <span class="font-normal">Indirizzo associato a documenti</span>
  </p-header>
  <div class="p-3">
    <p>L'indirizzo <b>{{indirizzoToHide?.nomeIndirizzo}}</b> è associato a uno o più documenti e non può essere eliminato.</p>
    <p>Vuoi nascondere questo indirizzo? Non sarà più visibile nelle selezioni per nuovi documenti.</p>
  </div>
  <p-footer>
    <button pButton type="button" label="Annulla" class="p-button-secondary" icon="pi pi-times" title="Annulla"
      (click)="cancelHide()"></button>
    <button pButton type="button" label="Nascondi" class="p-button-warning" icon="pi pi-eye-slash" title="Nascondi indirizzo"
      (click)="confirmHideIndirizzo()"></button>
  </p-footer>
</p-dialog>